module.exports = __webpack_public_path__ + "static/home-banner-img2-443d685c3a8e61ce81912f7b6107dfb4.png";